import { BlocksIconSyncronize } from 'blocks-nextjs/blocks-web-components/components/icon/icons/syncronize';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconSyncronize = createComponent({ react: React, tagName: 'cat-icon-syncronize', elementClass: BlocksIconSyncronize });
